import cardsStore from './cards'
import formStore from './forms'

export default {
  modules: {
    cards: {
      namespaced: true,
      ...cardsStore
    },
    forms: {
      namespaced: true,
      ...formStore
    }
  }
}
